module.exports = __webpack_public_path__ + "static/media/filter.14ecd41a.svg";